import { Row, Card, Col, Form } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useState } from "react";
import 'react-phone-input-2/lib/style.css'
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling';
import { useDispatch } from "react-redux"
import 'react-phone-input-2';
import { PageInfo } from "Components/PageInformation/PageInformation";
import { TextButton } from "Components/Button";
import {store} from 'Store';
import { openInNewTab } from "Utils/utilityFunctions";
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import { ERROR_MESSAGES} from "Utils/constants";
import { FormInputDisplay } from "Components/Forms/FormInputDisplay";
import { GetFeedbackTextInputData } from "./ThankYouFields";
import { saveComment } from "../OpenForCommentAxiosFuncs";
import { ACTIONS } from "Components/Forms/FormReducers/TextInputReducer";
import { getErrorList, submitAllAPI } from "../Util/Utilities";
import { constants } from "buffer";
import { config } from "Utils/config";

function ThankYou ({handleClear,show,handleClose,submitType, comments, categoryId, tempCommentListDispatch,commentsListDispatch,setStatusData,setStatusVariant,setShowStatusPopup}) {
    //const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [showTermsPopup, setShowTermsPopup] = useState(false);
    const [isSaveLoading, setIsSaveLoading] = useState(false);

    //const hForm = { is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 6 } };
    const vForm = { is: false, labelCols: { lg: 12, md: 12 }, inputCols: { lg: 12 } };

    var [firstName, firstNameInputDispatch] = GetFeedbackTextInputData('firstName', null);
    var [lastName, lastNameInputDispatch] = GetFeedbackTextInputData('lastName', null);
    var [email, emailInputDispatch] = GetFeedbackTextInputData('email', null);
    var [organization, organizationInputDispatch] = GetFeedbackTextInputData('organization', null);
    
   
    const submitGeneralComment = () => {
        
        firstNameInputDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            errors: []
        });
        lastNameInputDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            errors: []
        });
        emailInputDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            errors: []
        });
        organizationInputDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            errors: []
        });

        
        //console.log(submitType);
        if(submitType==="general"){
            // build document comment dto: mapping to DocumentComment.java
            const commentDto = {
                categoryId: null,
                itemId: null,
                firstName: firstName.value,
                lastName: lastName.value,
                organization: organization.value,
                email: email.value,
                comment: comments,
            }
            setIsSaveLoading(true);
            saveComment(commentDto).then((res) => {
                setIsSaveLoading(false);
                config.isDebugEnabled && console.log("submitGeneralComment() saveComment res", res);
                let statusCode = res?.data?.data?.statusCode;
                //console.log(statusCode);
                if (statusCode == 1) {
                    handleClose();
                    handleClear();
                    setStatusData({
                        title: "Success!",
                        message: "We've captured your comments; thank you for your feedback."
                    })
                    setStatusVariant("success");
                    setShowStatusPopup(true); 
                    
                    
                    
                } else {
                    // parse field error messages
                    let errCodeList = res?.data?.data?.errorCodeList;
                    let errMsgList = res?.data?.data?.errorMessageList;

                    if(errCodeList.length == errMsgList.length){
                        var obj = {

                        };
                        for(var x = 0 ; x<errCodeList.length ; x++){
                            var errField = errCodeList[x];

                            var field = errField.replace(/_\d+/,"");
                            var errMsg = errMsgList[x];

                            if(obj.hasOwnProperty(field)){
                                obj[field].push(errMsg);
                            }
                            else{
                                obj[field] = [errMsg];
                            }
                            
                        }
                        //console.log(obj);
                    }
                    for (const [key, value] of Object.entries(obj)) {
                        //console.log(`${key}: ${value}`);
                        switch(key){
                            case "firstname":
                                firstNameInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                            case "lastname":
                                lastNameInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                            case "email":
                                emailInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                            case "organization":
                                organizationInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                        }
                    }
                    
                    // build json object for the field error display
                    //buildValidationMsg(errCodeList, errMsgList);
                }
                setIsSaveLoading(false);
            }).catch((error) => {
                const globalMsg = error?.data?.globalErrorMessageList?.[0];
                setStatusData({
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    message: globalMsg ?? ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true);
            });
        }
        else{
            const commenter = {
                firstName: firstName.value,
                lastName: lastName.value,
                psoOrg: organization.value,
                email: email.value
            }
            //console.log(comments);
            //console.log(categoryId);
            const commentList = [];
            const cs = Object.values(comments);
            
            for(var x = 0 ; x<cs.length ; x++){
                var c = cs[x];
                //console.log(c);
                commentList.push({
                    domId: c.item.id,
                    categoryId: categoryId,
                    itemId: c.item.id,
                    //commentText: "ssssssssssssssssssssssssssssssssssssssssss<script",
                    commentText: c.input.value,
                    isGeneralComment: false
                })
                // commentList.push({
                //     domId: c.item.id,
                //     categoryId: categoryId,
                //     itemId: c.item.id,
                //     commentText: c.input.value,
                //     isGeneralComment: false
                // })
            }

            


            // console.log(commentList);
            // console.log(commenter);

            const data = {
                commenter: commenter,
                commentList: commentList
            }

            setIsSaveLoading(true);
            submitAllAPI(data).then(res => {
                setIsSaveLoading(false);
                //console.log(res);
                var r = getErrorList(res);
                //console.log(r);
                
                let statusCode = res?.data?.statusCode;
                if (statusCode === 1) {
                    commentsListDispatch({
                        type: "clear"
                    });
                    tempCommentListDispatch({
                        type: "clear"
                    });
                    // success
                    handleClose();
                    setStatusData({
                        title: "Success!",
                        message: "We've captured your comments; thank you for your feedback."
                    })
                    setStatusVariant("success");
                    setShowStatusPopup(true); 
                    
                    
                } else {
                    // parse field error messages
                    let errCodeList = res?.data?.errorCodeList;
                    let errMsgList = res?.data?.errorMessageList;

                    if(errCodeList.length == errMsgList.length){
                        var obj = {

                        };
                        for(var x = 0 ; x<errCodeList.length ; x++){
                            var errField = errCodeList[x];

                            var field = errField.replace(/_\d+/,"");
                            var errMsg = errMsgList[x];

                            if(obj.hasOwnProperty(field)){
                                obj[field].push(errMsg);
                            }
                            else{
                                obj[field] = [errMsg];
                            }
                            
                        }
                        //console.log(obj);
                    }
                    var close = false;
                    var focusId = null;
                    var firstDisp = null;
                    for (const [key, value] of Object.entries(obj)) {
                        //console.log(`${key}: ${value}`);
                        switch(key){
                            case "firstname":
                                firstNameInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                            case "lastname":
                                lastNameInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                            case "email":
                                emailInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                            case "organization":
                                organizationInputDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value
                                });
                                break;
                            default:
                                tempCommentListDispatch({
                                    type: ACTIONS.TEXT_SET_ERRORS,
                                    errors: value,
                                    name: key
                                });
                                //console.log(comments[key]);
                                if(comments[key]!=null){
                                    var dispOrder=comments[key].item.displayOrder;
                                    if(firstDisp==null || firstDisp > dispOrder){
                                        focusId=key;
                                        firstDisp=dispOrder;
                                    }
                                    
                                }
                                close=true;
                                break;
                        }
                    }
                    //console.log(focusId);
                    //console.log(dispOrder);
                    if(close==true){
                        var i = comments[focusId].item;
                        handleClose();
                        tempCommentListDispatch({
                            type: "update-comment-status",
                            name: i.id,
                            status: "edit"
                        })
                        
                        //console.log(i);
                    }
                    // build json object for the field error display
                    //buildValidationMsg(errCodeList, errMsgList);
                }
                setIsSaveLoading(false);
            }).catch((err)=>{
                config.isDebugEnabled && console.log(err);
                const globalMsg = err?.globalErrorMessageList?.[0];
                setStatusData({
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    message: globalMsg ?? ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true);
            })
        }

        
    }

    
    var popupButtons = [
        {
            text: "Submit",
            action: submitGeneralComment,
            variant: "comp-primary",
            className:'w-xs-100 w-sm-fit-content px-3',
            size: 'lg',
            disabled: isSaveLoading==true ? true : false
        },
        {
            text: "Cancel",
            action: handleClose,
            variant: "comp-outline",
            className:'w-xs-100 w-sm-fit-content px-3',
            size: 'lg'
            //disabled: false
        }
    ]

   
    return (
        <Row id="thankyou-popup" >
            <DynamicFormPopup
                showPopup = {show}
                handleClose = {handleClose}
                buttons = {popupButtons}
                title = {"Thank you for your feedback"}
                type= {"blank"}
                variant={"blank"}
                id="thankyou-popup"
            >
                <div className="m-0 d-flex body flex-column gap-4">
                    {/*<h2 tabindex="0" class="titlelabel" autofocus >PSOPPC Help Center</h2>*/}
                    <p className="mb-0">
                        AHRQ appreciates the time and effort you've taken to provide these comments for the further refinement of the Common Formats.
                    </p>
                    <p className="mb-0">
                        Prior to submitting your comments, you may attribute your comments to yourself and/or your organization here. If you'd prefer to remain anonymous, you may leave all fields blank and click the Submit button. If an email address is provided, you will receive an email confirming receipt of your comment.
                    </p>
                </div>
                <hr></hr>
                <Form className="gap-3 d-flex flex-column">
                    <FormInputDisplay rowClasses={"form-element-container"} fieldData={firstName} inputDispatch={firstNameInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={vForm}></FormInputDisplay>  
                    <FormInputDisplay rowClasses={"form-element-container"} fieldData={lastName} inputDispatch={lastNameInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={vForm}></FormInputDisplay>  
                    <FormInputDisplay rowClasses={"form-element-container"} fieldData={email} inputDispatch={emailInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={vForm}></FormInputDisplay>  
                    <FormInputDisplay rowClasses={"form-element-container"} fieldData={organization} inputDispatch={organizationInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={vForm}></FormInputDisplay>  
                                                
                </Form>
                
            </DynamicFormPopup>
        </Row>
    );
}

export default ThankYou;
